const backdropTransitionDurationMs = {
  enter: 200,
  exit: 150
};
const backdrop = "dibbowls5t";

export { backdrop, backdropTransitionDurationMs };
import "./organism.modal-container.style.linaria.module.css";
//# sourceMappingURL=organism.modal-container.style.js.map
